export default __webpack_public_path__ + "static/hp-d7687b7fb92144dd06b1edf7c59c6b03.svg";